import { MODEL_CONSTANTS } from "./constant";

export const showModel = (options: any) => {
  return {
    type: MODEL_CONSTANTS.SHOW_MODAL,
    payload: options,
  };
};

export const hideModel = () => {
  return {
    type: MODEL_CONSTANTS.HIDE_MODAL,
  };
};

export const pannelOpen = () => {
  return {
    type: MODEL_CONSTANTS.PANEL_OPEN,
  };
};

export const pannelClose = () => {
  return {
    type: MODEL_CONSTANTS.PANEL_CLOSE,
  };
};

export const showLoader = (content?: any) => {
  return {
    type: MODEL_CONSTANTS.SHOW_LOADER,
    payload: content,
  };
};

export const hideLoader = () => {
  return {
    type: MODEL_CONSTANTS.HIDE_LOADER,
  };
};

export const showToast = ({ type, content, lifetime,title,subtitle }: { type: string; content?: any; lifetime?: any,title?: any,subtitle?: any }) => {
  return {
    type: MODEL_CONSTANTS.SHOW_TOAST,
    payload: { type, content, lifetime,title,subtitle },
  };
};

export const hideToast = () => {
  return {
    type: MODEL_CONSTANTS.HIDE_TOAST,
  };
};
